<template>
  <div class="home">
    <modal
      height="auto"
      classes="msg-modal"
      width="300px"
      :adaptive="true"
      name="message"
      >{{ msg }}</modal
    >

    <modal
      height="auto"
      classes="desc-modal"
      width="400px"
      :adaptive="true"
      name="desc-panel"
    >
      <h4>{{ title }}</h4>
      <p>{{ desc }}</p>
    </modal>

    <modal
      height="auto"
      classes="img-modal"
      width="800px"
      :adaptive="true"
      name="img-panel"
    >
      <div @click="$modal.hide('img-panel')">
        <img class="large-img" :src="showUrl" alt="" />
      </div>
    </modal>
    <div>
      <div class="head">
        <img src="../assets/logo.png" class="logo" alt="" />

        <div class="float-right">
          <span class="lang-switch">
            <a
              v-if="this.$i18n.locale === 'zh'"
              @click="changeLang('en')"
              href="javascript:;"
              >EN</a
            >
            <a v-else @click="changeLang('zh')" href="javascript:;">中</a>
          </span>

          <span class="profile" v-if="currentAddress">
            {{ currentAddress.substr(0, 6) }}...{{
              currentAddress.substr(-4)
            }}</span
          >
          <span class="login-btn" v-else @click="login()">{{
            $t("i18n.connectWallet")
          }}</span>
        </div>
      </div>

      <div class="row">
        <span class="float-right search-wrap">
          <i class="iconfont iconsearch"></i>
          <input
            type="search"
            class="search-input"
            @input="search()"
            v-model="searchValue"
            :placeholder="$t('i18n.searchName')"
          />
        </span>
        <div class="chains">
          <div
            v-for="(c, index) in chains"
            v-bind:key="index"
            :class="['chain-item', chain === c ? 'active' : '']"
            @click="switchChain(c)"
          >
            <i :class="['icon-chain', c]"></i>
            <span> {{ c.toUpperCase() }} </span>
          </div>
        </div>
      </div>

      <p class="tips">
        {{ $t("i18n.tips") }}
        <a
          href="https://creativecommons.org/choose/zero/?lang=en"
          target="_blank"
        >
          {{ $t("i18n.cc0") }}
        </a>
      </p>
    </div>

    <div v-for="design in designList" class="cards card-wrap">
      <h2>
        {{ design.title }}
        <span class="float-right group-id"> # {{ design.group }}</span>
      </h2>
      <p class="subtitle">
        {{ $i18n.locale === "zh" ? design.descZh : design.descEn }}

        <span
          class="view-all"
          v-if="design.viewAll"
          @click="
            showDesc(
              design.title,
              $i18n.locale === 'zh' ? design.descZh : design.descEn
            )
          "
          >{{ $t("i18n.view") }}</span
        >
      </p>

      <!-- images -->
      <div
        v-if="design.layout === 'full'"
        :style="'background:' + design.bgColor"
        class="img-wrap"
      >
        <div class="left">
          <img
            @click="show(design.nfts[0].url)"
            :src="design.nfts[0].url"
            alt=""
          />

          <img
            @click="show(design.nfts[1].url)"
            :src="design.nfts[1].url"
            alt=""
          />
        </div>
        <div class="right">
          <img
            @click="show(design.nfts[2].url)"
            :src="design.nfts[2].url"
            alt=""
          />
        </div>
      </div>

      <div
        v-else-if="design.layout === 'full-three'"
        :style="'background:' + design.bgColor"
        class="img-wrap"
      >
        <div class="left">
          <img
            @click="show(design.nfts[0].url)"
            :src="design.nfts[0].url"
            alt=""
          />

          <img
            @click="show(design.nfts[1].url)"
            :src="design.nfts[1].url"
            alt=""
          />
        </div>
        <div class="right-width">
          <img
            @click="show(design.nfts[2].url)"
            :src="design.nfts[2].url"
            alt=""
          />
        </div>
      </div>

      <div
        v-else-if="design.layout === 'left'"
        :style="'background:' + design.bgColor"
        class="img-wrap"
      >
        <div class="left">
          <img
            @click="show(design.nfts[0].url)"
            :src="design.nfts[0].url"
            alt=""
          />
        </div>
        <div class="right">
          <img
            @click="show(design.nfts[1].url)"
            :src="design.nfts[1].url"
            alt=""
          />
        </div>
      </div>

      <div
        v-else-if="design.layout === 'single-width'"
        :style="'background:' + design.bgColor"
        class="img-wrap"
      >
        <div class="single-width">
          <img
            @click="show(design.nfts[0].url)"
            :src="design.nfts[0].url"
            alt=""
          />
        </div>
      </div>

      <div
        v-else-if="design.layout === 'single-height'"
        :style="'background:' + design.bgColor"
        class="img-wrap"
      >
        <div class="single-height">
          <img
            @click="show(design.nfts[0].url)"
            :src="design.nfts[0].url"
            alt=""
          />
        </div>
      </div>

      <div
        v-else-if="design.layout === 'top'"
        :style="'background:' + design.bgColor"
        class="img-wrap"
      >
        <div class="top">
          <img
            @click="show(design.nfts[0].url)"
            :src="design.nfts[0].url"
            alt=""
          />
        </div>
        <div class="bottom">
          <img
            @click="show(design.nfts[1].url)"
            :src="design.nfts[1].url"
            alt=""
          />
        </div>
      </div>

      <div class="info">
        <!-- <p>
          {{ $t("i18n.designBy") }}
          <span class="float-right">{{ design.author }}</span>
        </p> -->
        <p>
          {{ $t("i18n.price") }}
          <span class="float-right"
            >{{ currentChainPrice }} {{ nativeSymbolMap[chain] }}
          </span>
        </p>
        <p>
          {{ $t("i18n.totalMinted") }}
          <span class="float-right">{{
            groupsMinted[+design.group] || "-"
          }}</span>
        </p>

        <p>
          {{ $t("i18n.endTime") }}
          <span class="float-right">{{ endtime }}</span>
        </p>
      </div>

      <div class="btn-wrap">
        <span class="social-btns">
          <a
            v-if="design.fivedegrees"
            target="_blank"
            :href="design.fivedegrees"
          >
            <i class="icon-5degrees"></i>
          </a>
          <a v-if="design.twitter" target="_blank" :href="design.twitter">
            <i class="icon-twitter"></i>
          </a>
          <a v-if="design.website" target="_blank" :href="design.website">
            <i class="icon-website"></i>
          </a>
        </span>

        <span class="float-right">
          <button class="mint-btn" v-if="!ended" @click="mint(design.nfts)">
            {{ $t("i18n.mint") }}
          </button>
          <button class="mint-btn" disabled v-else>
            {{ $t("i18n.ended") }}
          </button>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import {
  NativeSymbolMap,
  ContractMap,
  ABI,
  NodeMap,
  ChainIdMap,
  IdChainMap,
  DesignList,
  MulticallContractMap,
  MULTI_ABI,
} from "../constants";
import Web3 from "web3";
import dayjs from "dayjs";
import _ from "lodash";
import HelloWorld from "@/components/HelloWorld.vue";
// import VConsole from "vconsole";

// var vc = new VConsole();

export default {
  name: "home",
  components: {
    HelloWorld,
  },
  data() {
    return {
      msg: "",
      desc: "",
      title: "",
      chains: ["eth", "bsc", "polygon", "heco", "ftm", "hsc"],
      chain: "",
      designList: DesignList,
      currentAddress: "",
      showUrl: "",
      groupsMinted: {},
      nativeSymbolMap: NativeSymbolMap,
      currentChainPrice: "",
      endtime: "",
      searchValue: "",
      ended: false,
    };
  },
  created() {},
  mounted() {
    if (navigator.userAgent.indexOf("TokenPocket") > -1) {
      setTimeout(() => {
        this.login();
      }, 1000);
    } else {
      this.login();
    }

    if (window.ethereum) {
      ethereum.on("accountsChanged", (account) => {
        this.login();
      });

      ethereum.on("chainChanged", (network) => {
        this.login();
      });
    }
  },
  methods: {
    changeLang(lang) {
      this.$i18n.locale = lang;
      localStorage.setItem("locale", lang);
    },
    showDesc(title, desc) {
      this.title = title;
      this.desc = desc;
      this.$modal.show("desc-panel");
    },
    showMsg(msg) {
      this.msg = msg;
      this.$modal.show("message");
      setTimeout(() => {
        this.$modal.hide("message");
      }, 3000);
    },
    show(url) {
      this.showUrl = url;
      this.$modal.show("img-panel");
    },
    search() {
      let searchString = _.trim(this.searchValue).toLowerCase();

      if (!searchString) {
        this.designList = DesignList;
      } else {
        let list = _.filter(DesignList, (item) => {
          return (
            String(item.group).indexOf(searchString) > -1 ||
            item.title.toLowerCase().indexOf(searchString) > -1
          );
        });

        this.designList = list;
      }
    },
    async mint(nfts) {
      if (!window.ethereum) {
        this.showMsg("Open in TokenPocket");
        return;
      }

      if (!this.currentAddress) {
        await this.login();
        return;
      }

      if (Number(window.ethereum.chainId) !== ChainIdMap[this.chain]) {
        await this.switchChain();
      }

      let contract = ContractMap[this.chain];
      if (!contract) {
        alert("Not support");
        return;
      }

      let web3 = new Web3(window.ethereum);
      let instance = new web3.eth.Contract(ABI, contract);
      let gas = "";

      let ids = _.map(nfts, (item) => item.id);

      let price = parseInt(+this.price);

      try {
        gas = await instance.methods
          .mint(ids)
          .estimateGas({ from: this.currentAddress, value: price });
      } catch (err) {
        if (err.message.indexOf("Coming soon") > -1) {
          this.showMsg("Not start yet");
        } else if (err.message.indexOf("already minted") > -1) {
          this.showMsg("Already minted");
        } else if (err.message.indexOf("Better luck next time") > -1) {
          this.showMsg("All NFT has been minted");
        } else {
          this.showMsg(err.message);
        }
        console.log(err);
      }

      if (!gas) {
        return;
      }

      instance.methods
        .mint(ids)
        .send({ from: this.currentAddress, value: price })
        .on("transactionHash", (hash) => {
          this.showMsg("Submitted");
        })
        .on("receipt", (receipt) => {
          this.showMsg("Success!");
          this.queryMinted();
        })
        .on("error", (err) => {
          this.handleError(err);
          // this.showMsg(err);
        });
    },
    handleError(err) {
      let errorMsg = err;

      if (typeof err === "string") {
        try {
          let errJson = JSON.parse(err);
          if (errJson.error && errJson.error.details.length) {
            errorMsg = errJson.error.details[0].message;
          } else if (errJson.error) {
            errorMsg = errJson.error.what;
          } else {
            errorMsg = errJson.message || errJson.code || errJson.msg;
          }
        } catch (e) {
          errorMsg = e;
        }
      } else {
        errorMsg = err.message || err.type || err.code;
      }

      this.showMsg(errorMsg);
    },
    async login() {
      if (window.ethereum) {
        try {
          let accounts = await ethereum.request({
            method: "eth_requestAccounts",
          });

          this.currentAddress = accounts[0].toLowerCase();
          this.chain = IdChainMap[Number(ethereum.chainId)];

          setTimeout(() => {
            this.queryMinted();
            this.queryPrice();
            this.queryEndTime();
          }, 1000);
        } catch (err) {
          console.log(err);
        }
      }
    },
    async queryEndTime() {
      let web3 = new Web3(window.ethereum);

      try {
        let contract = ContractMap[this.chain];

        let instance = new web3.eth.Contract(ABI, contract);

        let endtime = await instance.methods.end_time().call();

        this.ended = endtime * 1000 < new Date().getTime();

        this.endtime = dayjs(endtime * 1000).format("YYYY-MM-DD HH:mm:ss");
      } catch (err) {}
    },
    async queryPrice() {
      let web3 = new Web3(window.ethereum);

      try {
        let contract = ContractMap[this.chain];

        let instance = new web3.eth.Contract(ABI, contract);

        let price = await instance.methods.mint_price().call();

        this.price = price;

        this.currentChainPrice = parseFloat(price / Math.pow(10, 18));
      } catch (err) {
        console.log(err);
      }
    },
    async queryMinted() {
      let web3 = new Web3(window.ethereum);

      try {
        let contract = ContractMap[this.chain];

        let groups = _.filter(
          _.map(DesignList, (item) => item.group),
          (sub) => !!sub
        );

        let multiCallC = MulticallContractMap[this.chain];

        let multiCallInst = new web3.eth.Contract(MULTI_ABI, multiCallC);

        let groupParams = _.map(groups, (g) => [
          contract,
          "0x6f0a05c2" +
            web3.eth.abi.encodeParameter("uint256", g).substring(2),
        ]);
        // 批量查询每组
        let { returnData } = await multiCallInst.methods
          .aggregate(groupParams)
          .call();

        let groupsMinted = {};

        _.forEach(groups, (g, i) => {
          groupsMinted[+g] = Number(returnData[i]);
        });

        this.groupsMinted = groupsMinted;
      } catch (err) {
        console.log(err);
      }
    },
    async switchChain(chain) {
      let chainId = "0x" + ChainIdMap[chain || this.chain].toString(16);

      try {
        await ethereum.request({
          method: "wallet_switchEthereumChain",
          params: [{ chainId }],
        });

        this.login();
      } catch (switchError) {
        // This error code indicates that the chain has not been added to MetaMask.
        if (switchError.code === 4902) {
          try {
            await ethereum.request({
              method: "wallet_addEthereumChain",
              params: [
                {
                  chainId,
                  chainName: this.chain.toUpperCase(),
                  rpcUrls: [NodeMap[this.chain]],
                },
              ],
            });
          } catch (addError) {
            // handle "add" error
          }
        }
        // handle other "switch" errors
      }

      if (navigator.userAgent.indexOf("TokenPocket") > -1) {
        setTimeout(() => {
          location.reload(true);
        }, 1000);
      }
    },
  },
};
</script>

<style scoped lang="less">
.home {
  width: 1200px;
  margin: 0 auto 60px;

  .large-img {
    display: block;
    min-width: 400px;
    max-width: 800px;
    max-height: 800px;
    background: #fff;
    margin: 0 auto;
  }

  .search-wrap {
    position: relative;
  }

  .iconsearch {
    position: absolute;
    line-height: 40px;
    left: 12px;
    font-size: 20px;
    color: #999;
    z-index: 9;
  }

  .search-input {
    width: 320px;
    border-radius: 44px;
    -webkit-transition: none;
    transition: none;
    line-height: 24px;
    font-size: 13px;
    border: none;
    padding: 8px 20px 8px 44px;
  }

  .head {
    position: relative;
    overflow: hidden;
    padding: 24px 0 12px;
    margin: 0 12px;
  }

  .group-id {
    color: #ddd;
    font-size: 14px;
  }

  .tips {
    margin: 8px 0;
    padding: 0 12px;
  }

  .logo {
    height: 44px;
  }

  .login-btn,
  .profile {
    float: right;
    padding: 2px 44px;
    display: inline-block;
    vertical-align: middle;
    margin: 12px auto 8px;
    border-radius: 44px;
    line-height: 40px;
  }

  .login-btn {
    background-color: #0749f1;
    color: #fff;
  }

  .profile {
    background-color: #fff;
  }

  .lang-switch {
    display: inline-block;
    line-height: 64px;
    margin-right: 18px;
    a {
      color: #666;
      text-decoration: none;
    }
  }

  .card-wrap {
    width: 376px;
    display: inline-block;
    padding: 16px 22px;
    margin: 12px;
    border-radius: 32px;
    background: #ffffff;
    border: 1.21px solid #eeeeee;
    box-shadow: 0px 12px 24px 0px rgba(0, 0, 0, 0.1);
    box-sizing: border-box;

    h2 {
      font-size: 20px;
      margin: 12px 0 6px;
      line-height: 1.2;
    }

    .subtitle {
      position: relative;
      padding-right: 34px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 16px;
    }

    .view-all {
      position: absolute;
      right: 0;
      top: 1px;
      font-size: 14px;
      color: #0749f1;
      cursor: pointer;
    }

    p {
      font-size: 14px;
      margin: 6px 0;
      color: #666666;
    }

    .img-wrap {
      width: 330px;
      height: 330px;
      border-radius: 12px;
      margin: 12px 0;
      padding: 4px;

      .single-height,
      .single-width,
      .top,
      .bottom,
      .left,
      .right,
      .right-width {
        img {
          border: 1px solid #fff;
          border-radius: 12px;
          box-sizing: border-box;
        }
      }

      .single-width {
        width: 100%;
        height: 100%;
        line-height: 320px;
        padding: 4px;
        box-sizing: border-box;

        img {
          width: 100%;
          vertical-align: middle;
        }
      }
      .single-height {
        width: 100%;
        height: 100%;
        padding: 4px;
        box-sizing: border-box;

        img {
          height: 100%;
          margin: 0 auto;
          display: block;
        }
      }

      .top {
        margin: 4px auto 8px;
        width: 240px;
        height: 240px;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .bottom {
        margin: 0 auto;
        width: 240px;
        height: 70px;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .left {
        display: inline-block;
        width: 50%;
        box-sizing: border-box;
        padding: 4px;
        vertical-align: top;
        img {
          width: 100%;
        }
      }

      .right-width {
        padding: 4px;
        display: inline-block;
        width: 50%;
        height: auto;
        box-sizing: border-box;

        img {
          width: 100%;
          height: auto;
        }
      }

      .right {
        padding: 4px;
        display: inline-block;
        width: 50%;
        height: 100%;
        box-sizing: border-box;

        img {
          width: 100%;
          height: 100%;
        }
      }
    }

    .btn-wrap {
      overflow: hidden;
      margin: 18px 0;

      .social-btns {
        display: inline-block;
        padding: 2px 0;

        a {
          display: inline-block;
          float: left;
        }

        i {
          display: inline-block;
          float: left;
          width: 40px;
          height: 40px;
          margin-right: 10px;
          background-size: 100% 100%;
          background-repeat: no-repeat;
        }

        .icon-5degrees {
          background-image: url("../assets/5degrees.png");
        }

        .icon-website {
          background-image: url("../assets/website.png");
        }

        .icon-twitter {
          background-image: url("../assets/twitter.png");
        }
      }

      .mint-btn {
        cursor: pointer;
        font-size: 18px;
        border-radius: 30px;
        padding: 12px 48px;
        color: #0749f1;
        background-color: #fff;
        border: 1px solid #0749f1;

        &:disabled {
          background-color: #ddd;
          color: #fff;
          border-color: #ddd;
        }

        &:hover {
          background-color: #0749f1;
          color: #fff;

          &:disabled {
            background-color: #ddd;
            color: #fff;
            border-color: #ddd;
          }
        }
      }
    }
  }

  .row {
    margin: 6px 12px 16px;
  }

  .chains {
    display: inline-block;

    border-radius: 40px;
    overflow: hidden;
    border: 1px solid #d7d7d7;

    .chain-item {
      background-color: #fff;
      display: inline-block;
      vertical-align: middle;
      font-size: 16px;
      line-height: 38px;
      padding: 0 24px;
      cursor: pointer;
      border-right: 1px solid #d7d7d7;

      &:last-child {
        border-right: none;
      }

      &.active {
        background-color: #0749f1;
        color: #fff;
      }

      i,
      span {
        display: inline-block;
        vertical-align: middle;
      }

      .icon-chain {
        width: 16px;
        height: 16px;
        background-size: 100% 100%;
        margin-right: 6px;

        &.eth {
          background-image: url(../assets/chains/eth.svg);
        }
        &.bsc {
          background-image: url(../assets/chains/bsc.svg);
        }
        &.polygon {
          background-image: url(../assets/chains/polygon.svg);
        }
        &.hsc {
          background-image: url(../assets/chains/hsc.png);
        }
        &.heco {
          background-image: url(../assets/chains/heco.svg);
        }
        &.ftm {
          background-image: url(../assets/chains/fantom.svg);
        }
      }
    }
  }
}

@media screen and (max-width: 640px) {
  .home {
    width: auto;
    margin: 0 12px;

    .logo {
      height: 36px;
    }

    .lang-switch {
      line-height: 38px;
    }

    .row {
      margin: 6px 12px;
    }

    .search-wrap,
    .search-input {
      width: 100%;
    }

    .tips {
      padding: 0 12px;
    }

    .login-btn,
    .profile {
      padding: 2px 24px;
      display: inline-block;
      vertical-align: middle;
      margin: 0 auto;
      border-radius: 44px;
      line-height: 34px;
    }

    .chains {
      display: inline-block;
      margin: 12px 0 8px;
      border-radius: 0;
      max-width: 100%;
      overflow: auto;
      border: none;
      white-space: nowrap;
      padding-bottom: 8px;

      .chain-item {
        background-color: #fff;
        display: inline-block;
        vertical-align: middle;
        font-size: 16px;
        line-height: 38px;
        border-radius: 12px;
        padding: 0 12px;
        cursor: pointer;
        border: 1px solid #d7d7d7;
        margin-right: 2px;

        &:last-child {
          border-right: none;
        }

        &.active {
          background-color: #0749f1;
          color: #fff;
        }

        .icon-chain {
          display: none;
        }
      }
    }

    .large-img {
      min-width: 350px;
      max-width: 390px;
      max-height: 600px;
    }

    // .chains {
    //   .chain-item {
    //     // padding: 2px 4px;
    //     font-size: 13px;

    //     .icon-chain {
    //       width: 14px;
    //       height: 14px;
    //     }
    //   }
    // }

    .profile {
      font-size: 13px;
    }

    .card-wrap {
      width: 100%;
      padding: 12px 16px 8px;
      margin: 12px 0;
      border-radius: 32px;
      background: #ffffff;
      border: 1.21px solid #eeeeee;
      box-shadow: 0px 12px 24px 0px rgba(0, 0, 0, 0.1);
      box-sizing: border-box;

      h2 {
        font-size: 20px;
        margin: 12px 0 6px;
        line-height: 1.2;
      }

      .subtitle {
        font-size: 16px;
      }

      p {
        font-size: 14px;
        margin: 6px 0;
        color: #666666;
      }

      .img-wrap {
        border-radius: 12px;
        margin: 12px auto;
      }

      .btn-wrap {
        overflow: hidden;
        margin: 18px 0;

        .mint-btn {
          cursor: pointer;
          font-size: 18px;
          border-radius: 30px;
          padding: 12px 48px;
          color: #0749f1;
          background-color: #fff;
          border: 1px solid #0749f1;

          &:hover {
            background-color: #0749f1;
            color: #fff;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 390px) {
  .home {
    .large-img {
      min-width: 300px;
      max-width: 350px;
      max-height: 580px;
    }

    .card-wrap {
      .img-wrap {
        width: 300px;
        height: 300px;

        .single-width {
          line-height: 290px;
        }

        .top {
          width: 210px;
          height: 210px;
        }
        .bottom {
          width: 210px;
        }
      }
    }
  }
}

@media screen and (max-width: 359px) {
  .home {
    .large-img {
      min-width: 280px;
      max-width: 320px;
      max-height: 550px;
    }
    .card-wrap {
      .img-wrap {
        width: 270px;
        height: 270px;

        .single-width {
          line-height: 260px;
        }

        .top {
          width: 180px;
          height: 180px;
        }
        .bottom {
          width: 180px;
        }
      }
    }
  }
}
</style>
